'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import MontoMask from "../../../../../Common/Components/Mask/MontoMask.jsx"
import DateMask from "../../../../../Common/Components/Mask/DateMask.jsx"

class PagosRegistradosRow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { pagoRegistrado } = this.props;

        return <tr>
            <td>
                <label className="label-saldos-resumenes-body"><DateMask fecha={pagoRegistrado.FechaCierre} /></label>
            </td>
            <td>
                <label className="label-saldos-resumenes-body">{pagoRegistrado.OrigenCanalPago}</label>
            </td>

            {pagoRegistrado.Moneda == "PESO" ?
                <td>
                    <MontoMask class={"label-saldos-resumenes-body"} monto={pagoRegistrado && pagoRegistrado.Importe} moneda={"PESO"} />
                </td>
                :
                <td>
                    <label className="label-saldos-resumenes-body">-</label>
                </td>}

            {pagoRegistrado.Moneda == "DOLAR" ?
                <td>
                    <MontoMask class={"label-saldos-resumenes-body"} monto={pagoRegistrado && pagoRegistrado.Importe} moneda={"DOLAR"} />
                </td>
                :
                <td>
                    <label className="label-saldos-resumenes-body">-</label>
                </td>}
        </tr>
    }

}
export default PagosRegistradosRow;